module.exports = __webpack_public_path__ + "media/answer_reveal.5acc4c35.mp3";